import React, { useEffect, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";


import { useDispatch, useSelector } from "react-redux";
import Select from './Select';
import Checkbox from './Checkbox';

export default function InfoViewlists(props) {

    const { 
        titles='',
        rightButtons=false,
        rightButtonsCount=[],
        selectdata1=[],
        selectdata2=[],
        selectdata3=[],
        lists=[],
        styles='infoviewstyle1',
        setrightButtons=() => {},
        liststyle2arr=[],
        p_code='',
        listdongNames=null,
        setlistdongNames=() => {},
        setplistdong=()=>{},
        setplistfloor=()=>{},
        setplistho=()=>{},
        setproductinfoArr=()=>{},
        floorDatas=0
    } = props;


    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [listViewflag, setlistViewflag] = useState(true);   
    const [listdong, setlistdong] = useState([]);   
    const [listfloor, setlistfloor] = useState([]);   
    const [listho, setlistho] = useState([]);   
    const [listdongv, setlistdongv] = useState('');   
    const [listfloorv, setlistfloorv] = useState('');   
    const [listhov, setlisthov] = useState('');

    const [listS2Checks, setlistS2Checks] = useState([]); 

    let selectlists = rightButtonsCount?.map((x, i) => {
        return {labels: `${x['동명'] || '-'}`, values: i}
    });
    selectlists.sort((a, b) => {
        return a.labels < b.labels ? -1 : a.labels > b.labels ? 1 : 0;
    });
    if(styles === 'infoviewstyle2'){
        // console.log(liststyle2arr);
    }
    const groupBy = (xs, key) => {
        return xs.reduce(function(rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    }
    useEffect(() => {
        console.log("floorDatasfloorDatasfloorDatas", floorDatas);
        setTimeout(() => {
            setproductinfoArr((val) => {
                return val?.map((x2, i2) => x2?.key === 'building_dong_floor_all' ? { ...x2, values: floorDatas} : x2 );
            });
        }, 500);
    }, [floorDatas]);
    useEffect(() => {
        
        let setArrs = liststyle2arr?.map(x => { 
            x['층이름'] = `${x['층구분코드명']} ${x['층번호']}층`;
            x['정렬'] = `${x['층구분코드명'] === '지하' ? 'a' : 'b'}${x['층번호']*1 < 10 ? '0'+x['층번호'] : x['층번호']}`;
            return x;
        })
        setArrs.sort((a, b) => {
            return a['정렬'] < b['정렬'] ? -1 : a['정렬'] > b['정렬'] ? 1 : 0;
        });

        let floorlists = [];
        if(listdongv){
            floorlists = setArrs?.filter(item => item['동명'] === listdongv && item['전유공용구분코드']*1 === 1 );
        }


        let groubedByTeam = groupBy(setArrs, '동명');
        let listfloors = [];
        if(listdongv){
            listfloors = groupBy(floorlists?.filter(item => item['동명'] === listdongv ), '층이름');
        } else {
            listfloors = groupBy(setArrs, '층이름');
        }

        let keydongs = Object.keys(groubedByTeam)?.filter(item => item !== '');

        let keyfloors = Object.keys(listfloors);
        // //console.log(Object.keys(reviewOptions), type0filter, type1filter);
        keydongs = keydongs?.map((x, i) => {
            return {labels: x, values: x}
        })
        keyfloors = keyfloors?.map((x, i) => {
            //console.log("xxx", listfloors);
            return {labels: x, values: x}
        })

        let holists = [];
        if(!listdongv){
            holists = setArrs?.filter(item => item['층이름'] === listfloorv && item['전유공용구분코드']*1 === 1 )?.map((x, i) => {
                //console.log(x);
                return {labels: x['호명'], values: x['호명']}
            })
        } else {
            holists = setArrs?.filter(item => item['동명'] === listdongv && item['층이름'] === listfloorv && item['전유공용구분코드']*1 === 1 )?.map((x, i) => {
                //console.log(x);
                return {labels: x['호명'], values: x['호명']}
            })
        }

        keydongs.sort((a, b) => {
            return a.labels < b.labels ? -1 : a.labels > b.labels ? 1 : 0;
        });
        holists.sort((a, b) => {
            return a.labels < b.labels ? -1 : a.labels > b.labels ? 1 : 0;
        });
        holists = holists.filter(function(item1, idx1){
            //filter() 메서드는 콜백함수에서 정의한 조건이 true인 항목만 리턴한다.(필터링)
            return holists.findIndex(function(item2, idx){
                //findIndex() 메서드는 콜백함수에 정의한 조건이 true인 항목의 index를 리턴한다.
                return item1.labels == item2.labels
            }) == idx1;
        });
        setlistdong(keydongs);
        setlistfloor(keyfloors);
        setlistho(holists);

        if(!listdongv){

            //console.log("aasdfasdf1", keydongs, keyfloors, holists);

            setlistdongv(keydongs[0]?.values);
            return;
        }
        if(!listfloorv){
            //console.log("aasdfasdf2", listdongv, listfloorv, listhov);

            setlistfloorv(keyfloors[0]?.values);
            return;
        }
        if(!listhov){
            setlisthov(holists[0]?.values);
            return;
        }
    }, [listdongv, listfloorv]);

    useEffect(()=>{
        // 호실 변경에 따른 면적 선택 초기화
        let defaultList = []
        if(listdong?.length > 0){
            liststyle2arr?.filter(item => item['동명'] === listdongv && item['층이름'] === listfloorv && item['호명'] === listhov).map((v,i)=>{
                if(v['전유공용구분코드명'] === '전유')
                    defaultList.push(i);
                return v
            })
        }else{
            liststyle2arr?.filter(item => item['층이름'] === listfloorv && item['호명'] === listhov).map((v,i)=>{
                if(v['전유공용구분코드명'] === '전유')
                    defaultList.push(i);
                return v
            })
        }
        setlistS2Checks(defaultList)
    } , [listhov])

    // 호실정보 선택값 합
    const sumListS2Func = ()=>{
        if(listdong?.length > 0 ){
            return liststyle2arr?.filter(item => item['동명'] === listdongv && item['호명'] === listhov).filter((v,i) => listS2Checks.includes(i)).reduce((pv, cur)=>{
                if(!isNaN(Number(cur['면적'])))
                    pv += Number(cur['면적'])
                return pv
            }, 0)
        }else{
            return liststyle2arr?.filter(item => item['층이름'] === listfloorv && item['호명'] === listhov).filter((v,i) => listS2Checks.includes(i)).reduce((pv, cur)=>{
                if(!isNaN(Number(cur['면적'])))
                    pv += Number(cur['면적'])
                return pv
            }, 0)
        }

        console.log("sumListS2Func",listS2Checks.toString())
    }

    if(styles === 'infoviewstyle2'){
        return (
            <div className={styles}>
                <div>
                    <button type="button" onClick={() => { setlistViewflag(!listViewflag); }}>
                        <span className='bolds'>{titles}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                            <g clipPath="url(#clip0_5837_11080)">
                            <path d="M4.44434 8.27783L9.99989 13.8334L15.5554 8.27783H4.44434Z" fill="#333333"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_5837_11080">
                            <rect width="20" height="20" fill="white" transform="translate(0 0.5)"/>
                            </clipPath>
                        </defs>
                        </svg>                    
                    </button>

                </div>
                {listViewflag === true &&
                <>
                    <div>
                        {/* {listdong?.length}-
                        {listfloor?.length}-
                        {listho?.length}- */}
                        {listdong?.length > 0 && 
                            <Select 
                                styles={{}}
                                setValues={(e) => {
                                    setlistfloorv('');
                                    setlisthov('');
                                    setlistdongv(e);
                                }}
                                values={listdongv}
                                selectData={listdong}
                                subselectClass={'fontsize12'}
                            /> 
                        }
                        {listfloor?.length > 0 && 
                            <Select 
                                styles={{}}
                                setValues={(e) => {
                                    setlisthov('');
                                    setlistfloorv(e);
                                }}                                
                                values={listfloorv}
                                selectData={listfloor}
                                subselectClass={'fontsize12'}
                            /> 
                        }
                        {listho?.length > 0 && 
                            <Select 
                                styles={{}}
                                setValues={setlisthov}
                                values={listhov}
                                selectData={listho}
                                subselectClass={'fontsize12'}
                            /> 
                        }                                        
                    </div>
                    {listdong?.length > 0 ?
                    <>
                        {liststyle2arr?.filter(item => item['동명'] === listdongv && item['층이름'] === listfloorv && item['호명'] === listhov)?.length > 0 &&
                        <div>
                            <button onClick={()=>{ 
                                let _infoList = liststyle2arr?.filter(item => item['동명'] === listdongv && item['호명'] === listhov);
                                if(_infoList?.length === listS2Checks.length){
                                    // 전체 해제를 할 경우
                                    setlistS2Checks([])
                                }else{
                                    // 전체 선택을 할 경우
                                    setlistS2Checks([..._infoList?.map((_,i)=> i)])
                                }
                            }}>
                                {
                                liststyle2arr?.filter(item => item['동명'] === listdongv && item['호명'] === listhov)?.length === listS2Checks.length ? // 전체 선택이 되어 있으면
                                "전체해제" :
                                "전체선택"
                                }
                            </button>
                            {liststyle2arr?.filter(item => item['동명'] === listdongv && item['호명'] === listhov)?.map((x, i) => {
                                // console.log(listdongv, listfloorv, listhov);
                                return (
                                    <div key={i}>
                                        <div>
                                            <input 
                                                type='checkbox'
                                                onChange={(e)=>{
                                                    setlistS2Checks(v => {
                                                        if(e.target.checked){
                                                            v.push(i)
                                                        }else{
                                                            let delIndex = listS2Checks.indexOf(i)
                                                            if(delIndex >= 0)
                                                                v.splice(delIndex, 1);
                                                        }
                                                        // console.log("IIII",v)
                                                        return [...v]
                                                    })
                                                }}
                                                checked={listS2Checks.includes(i)}
                                            />
                                        </div>
                                        <div>{x['전유공용구분코드명']}</div>
                                        <div>{x['층이름']}</div>
                                        <div>{x['기타용도']}</div>
                                        <div>{x['면적']}㎡</div>
                                    </div>
                                );
                            })}
                        </div>}          
                    </>
                    :
                    <>
                        {liststyle2arr?.filter(item => item['층이름'] === listfloorv && item['호명'] === listhov)?.length > 0 &&
                        <div>
                            <button onClick={()=>{ 
                                let _infoList = liststyle2arr?.filter(item => item['층이름'] === listfloorv && item['호명'] === listhov);
                                if(_infoList?.length === listS2Checks.length){
                                    // 전체 해제를 할 경우
                                    setlistS2Checks([])
                                }else{
                                    // 전체 선택을 할 경우
                                    setlistS2Checks([..._infoList?.map((_,i)=> i)])
                                }
                            }}>
                                {
                                liststyle2arr?.filter(item => item['층이름'] === listfloorv && item['호명'] === listhov)?.length === listS2Checks.length ?
                                "전체해제" :
                                "전체선택"
                                }
                            </button>
                            {liststyle2arr?.filter(item => item['층이름'] === listfloorv && item['호명'] === listhov)?.map((x, i) => {
                                return (
                                    <div key={i}>
                                        <div>
                                            <input 
                                                type='checkbox'
                                                onChange={(e)=>{
                                                    setlistS2Checks(v => {
                                                        if(e.target.checked){
                                                            v.push(i)
                                                        }else{
                                                            let delIndex = listS2Checks.indexOf(i)
                                                            if(delIndex >= 0)
                                                                v.splice(delIndex, 1);
                                                        }
                                                        return [...v]
                                                    })
                                                }}
                                                checked={listS2Checks.includes(i)}
                                            />
                                        </div>
                                        <div>{x['전유공용구분코드명']}</div>
                                        <div>{x['층이름']}</div>
                                        <div>{x['기타용도']}</div>
                                        <div>{x['면적']}㎡</div>
                                    </div>
                                );
                            })}
                        </div>}
                    </>
                    }
                </>
                }
                {listdong?.length > 0 ? 
                    <p style={{marginTop:4, fontWeight:700}}>선택 값 합계 : {sumListS2Func().toFixed(3)}㎡ (약 {Math.floor(sumListS2Func()/3.3057)}평)</p> :
                    <p>선택 값 합계 : {sumListS2Func().toFixed(3)}㎡ (약 {Math.floor(sumListS2Func()/3.3057)}평)</p>}
            </div>
        );
    } else if(styles === 'infoviewstyle3'){
        //console.log(lists);
        let filterlists = lists?.sublists;
        let codefilter1 = filterlists?.filter(item => item['용도지역지구코드'].substr(0, 2) === 'UQ'); //국토의 계획 및 이용에 관한 법률
        let codefilter2 = filterlists?.filter(item => item['용도지역지구코드'].substr(0, 2) !== 'UQ'); //그외 기타 법률

        let filtertypeArr1 = {
            '포함' : codefilter1?.filter(item => item['저촉여부'] === '포함')?.map(item => item['용도지역지구명'])?.join(",") || '-',
            '저촉' : codefilter1?.filter(item => item['저촉여부'] === '저촉')?.map(item => item['용도지역지구명'])?.join(",") || '-',
            '접함' : codefilter1?.filter(item => item['저촉여부'] === '접함')?.map(item => item['용도지역지구명'])?.join(",") || '-'
        }
        let filtertypeArr2 = {
            '포함' : codefilter2?.filter(item => item['저촉여부'] === '포함')?.map(item => item['용도지역지구명'])?.join(",") || '-',
            '저촉' : codefilter2?.filter(item => item['저촉여부'] === '저촉')?.map(item => item['용도지역지구명'])?.join(",") || '-',
            '접함' : codefilter2?.filter(item => item['저촉여부'] === '접함')?.map(item => item['용도지역지구명'])?.join(",") || '-'
        }
        //console.log(filtertypeArr1);
        //console.log(filtertypeArr2);


        //codefilter1?.filter(item => item.type === 1)?.map(item => item.title)?.join(", ") || '-'
        return (
            <div className='infoviewstyle1'>
                <div>
                    <button type="button" onClick={() => { setlistViewflag(!listViewflag); }}>
                        <span className='bolds'>{titles}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                            <g clipPath="url(#clip0_5837_11080)">
                            <path d="M4.44434 8.27783L9.99989 13.8334L15.5554 8.27783H4.44434Z" fill="#333333"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_5837_11080">
                            <rect width="20" height="20" fill="white" transform="translate(0 0.5)"/>
                            </clipPath>
                        </defs>
                        </svg>                    
                    </button>
                </div>
                {listViewflag === true &&
                <>
                    <div>
                        <div >
                            <div style={{ width: 40 }}>주소</div>
                            <div style={{ width: 'calc(100% - 40px)'}}>{lists?.title[0]?.['법정동명']} {lists?.title[0]?.['지번']}</div>
                        </div>
                        <div >
                            <div style={{ width: 40 }}>지목</div>
                            <div style={{ width: 'calc(100% - 40px)'}}>{lists?.title[0]?.['지목명']}</div>
                        </div>
                        <div >
                            <div style={{ width: 40 }}>면적</div>
                            <div style={{ width: 'calc(100% - 40px)'}}>{(lists?.title[0]?.['면적']*1).toFixed(1)} ㎡</div>
                        </div>
                    </div>
                    
                    <div className='infoviewstyle1' style={{ padding: 0, borderRadius: 0, border: 0, marginTop: 20 }}>
                        <div>
                            <button type="button" onClick={() => {}}>
                                <span className='bolds'>국토의 계획 및 이용에 관한 법률</span>
                            </button>
                        </div>
                        <div>
                            <div >
                                <div style={{ width: 40 }}>포함</div>
                                <div style={{ width: 'calc(100% - 40px)'}}>{filtertypeArr1['포함']}</div>
                            </div>
                            <div >
                                <div style={{ width: 40 }}>저촉</div>
                                <div style={{ width: 'calc(100% - 40px)'}}>{filtertypeArr1['저촉']}</div>
                            </div>
                            <div >
                                <div style={{ width: 40 }}>접함</div>
                                <div style={{ width: 'calc(100% - 40px)'}}>{filtertypeArr1['접함']}</div>
                            </div>
                        </div>
                    </div>
                    <div className='infoviewstyle1' style={{ padding: 0, borderRadius: 0, border: 0, marginTop: 20 }}>
                        <div>
                            <button type="button" onClick={() => {}}>
                                <span className='bolds'>기타 법률</span>
                            </button>
                        </div>
                        <div>
                            <div >
                                <div style={{ width: 40 }}>포함</div>
                                <div style={{ width: 'calc(100% - 40px)'}}>{filtertypeArr2['포함']}</div>
                            </div>
                            <div >
                                <div style={{ width: 40 }}>저촉</div>
                                <div style={{ width: 'calc(100% - 40px)'}}>{filtertypeArr2['저촉']}</div>
                            </div>
                            <div >
                                <div style={{ width: 40 }}>접함</div>
                                <div style={{ width: 'calc(100% - 40px)'}}>{filtertypeArr2['접함']}</div>
                            </div>
                        </div>
                    </div>

                </>
                }

            </div>
        );
    } else {
        return (
            <div className={styles}>
                <div>
                    <button type="button" onClick={() => { setlistViewflag(!listViewflag); }}>
                        <span className='bolds'>{titles}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                            <g clipPath="url(#clip0_5837_11080)">
                            <path d="M4.44434 8.27783L9.99989 13.8334L15.5554 8.27783H4.44434Z" fill="#333333"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_5837_11080">
                            <rect width="20" height="20" fill="white" transform="translate(0 0.5)"/>
                            </clipPath>
                        </defs>
                        </svg>                    
                    </button>
                    {rightButtons === true &&
                    <div style={{ width: 120 }}>
                        <Select 
                            divwidth={{  height: 30 }}
                            styles={{ height: 30 }}                                            
                            setValues={(e) => {
                                setlistdongNames(selectlists?.find(item => item?.values*1 === e*1)?.labels === '-' ? '' : selectlists?.find(item => item?.values*1 === e*1)?.labels);
                                setrightButtons(e*1);
                            }}
                            values={0}
                            selectData={selectlists}
                        />
                    </div>
                    }
                </div>
                {listViewflag === true && lists?.length > 0 &&
                <div>
                    {lists?.map((x, i) => {
                        return (
                            <div key={i}>
                                <div>{x?.viewnames}</div>
                                <div>{x?.values}<br />{x?.values1}</div>
                            </div>
                        );
                    })}
                </div>
                }
            </div>
        );    
    }
}